// Sprint 56 — refined page header used across admin pages. Optional icon,
// tighter type scale so it composes nicely with the sticky admin top bar.
export default function PageHeader({ title, subtitle, actions, icon: Icon, testId }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 mb-5 md:mb-7"
      data-testid={testId || "page-header"}
    >
      <div className="min-w-0 flex items-center gap-3">
        {Icon && (
          <div className="hidden md:grid w-11 h-11 rounded-xl bg-primary/10 text-primary place-items-center shrink-0">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-[22px] md:text-3xl font-display font-bold text-foreground leading-tight tracking-tight truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xs md:text-sm text-muted-foreground mt-0.5 md:mt-1 truncate">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap md:justify-end">{actions}</div>}
    </div>
  );
}
